import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import DataTableComponent from "../../common/DataTable/PrimeDataTable";
import PublishActivateDeactivateModal from '../../common/PublishActivateDeactivateModal';
import publish_status from '../../common/publish_status';


// TODO: use publish_status for status column
// TODO: Admin can deactivate workflow only workflows do not publish or published without requests in progress in interface portal.

const WFList = ({persona}) => {
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [confirmActivateModal, setConfirmActivateModal] = useState({ open: false, record: null });

  const navigate = useNavigate();
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: 'createdAt',
    sortOrder: -1,
    filters: {}
  });

  const onDataTableEvent = (event) => {
    setPaginationParams(prev => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder
    }));
  };/* The commented out code block is a function named `fetchWorkflows` that is using an asynchronous
  function to make a GET request to a specific API endpoint
  (`${process.env.REACT_APP_SERVER_URL}/api/workflows`) to fetch workflow data. The function is
  using `axiosInstance` to make the HTTP request with credentials included. */
  

  // const fetchWorkflows = async () => {
  //   const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/workflows`, { withCredentials: true })
  //   .catch((err) => {
  //       console.log(err);
  //   });

  //   setData(response?.data);
  // };

  const fetchWorkflows = async () => {
    try {
        const workflowsResponse = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/workflows`, { withCredentials: true });
        const serverWorkflowData = (workflowsResponse?.data || []).map(item => ({
          ...item,
          type: 'workflow'
        }));

        const draftsResponse = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/workflows-drafts`, { withCredentials: true });
        const serverDraftsData = (draftsResponse?.data || []).map(item => ({
          ...item,
          type: 'draft'
        }));

        // Add Drafts to workflows in response JSON
        const combinedData = [...serverWorkflowData, ...serverDraftsData];
        const updatedResponse = { ...workflowsResponse, data: combinedData };

        console.log("Updated response:", updatedResponse);

        setData(updatedResponse.data);
    } catch (err) {
        console.error("Error fetching workflows:", err);
    }
  };

  useEffect(() => {
    fetchWorkflows();
  }, [paginationParams]);

  const columns = [
    //ID, name, No. of stages, created by, creation date, status, and actions (Edit, Deactivate/ activate)
    { field: "id", header: "ID", sortable: true },
    { field: "name", header: t("name"), sortable: true, filter: true, body: (rowData) => { return rowData.type === 'draft' ? `DRFT:${rowData.name}` : rowData.name } },
    { field: "num_stages", header: t("num_stages"), sortable: true, filter: true, body: (rowData) => { return rowData.WorkflowVersions && rowData.WorkflowVersions[0] ? rowData.WorkflowVersions[0].num_stages : rowData.type === 'draft' ? rowData.num_stages : "N/A"; } },
    { field: "createdBy", header: t("createdBy"), sortable: true, filter: true },
    { field: "createdAt", header: t("createdAt"), sortable: true, filter: true, body: (rowData) => new Date(rowData.createdAt).toLocaleString('en-GB') },
    //TODO: reactivate publish status -> { field: "status", header: t("status"), sortable: true, filter: true, body: (rowData) => rowData.published === 1 ? <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#198754" }} /> : <FontAwesomeIcon icon={faCircleXmark} style={{ color: "#ff0000" }} /> },
  ];

  const actions = [
    { text: t("View Versions"), color: "secondary", onClick: (row) => { return navigate(row.type === 'draft' ? `/${persona}/workflows/draft/${row.id}` : `/${persona}/workflows/${row.id}/versions`) }},
    { text: 'Publish / Activate / Deactivate', color: "primary", visible: (row) => {
      // console.log("Row publishedAt:", row.publishedAt);
      return row.publishedAt && row.publishedAt.trim() !== "";
    }
    , onClick: (row) => setConfirmActivateModal({ open: true, record: row }) ,status:"success"}
  ];

  return (
    <div>

      <DataTableComponent
      data={data}
      columns={columns}
      actions={actions}
      onDataTableEvent={onDataTableEvent}
      paginationParams={paginationParams}
      totalRecords={data?.length}
      enableCreate={true}
      enablePagination={true}
      enableLazyLoading={false}
      enableExport={true}
      // enableSelection= {true}
      // selection={selectedRows}
      // onSelectionChange={(e) => setSelectedRows(e.value)}
      // selectionMode="multiple"
      />

      {confirmActivateModal.open && (
          <PublishActivateDeactivateModal
            sentData={confirmActivateModal.record}
              onEvent={setConfirmActivateModal}
              onConfirm={fetchWorkflows}
              apiPath="workflows"
              axios={axiosInstance}
              columnName="name"
              dbAction="status"
              sectionName={"Workflows"}
          />
        )}
          
    </div>
  );
};

export default WFList;